import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { of } from 'rxjs';
import { Observable } from 'rxjs';
import { switchMap, map } from 'rxjs/operators';
import { ApiService, Carrello, Indirizzo, ProdottoCarrello } from './api.service';
import { AuthService } from './auth.sevice';
import { HeaderService } from './header.service';
import { StorageService } from './storage.service';

@Injectable({providedIn: 'root'})
export class PreferitiService {
  constructor(
    private storage: StorageService,
    private apiService: ApiService,
    private translate: TranslateService,
    private header: HeaderService
  ) { }

  getPreferiti(): Observable<any> {
    if (this.storage.isBrowser) {
      const preferitiInSessione = this.storage.getLocal('preferiti-stem');
      return preferitiInSessione ? of(preferitiInSessione) : this.aggiornaPreferiti();
    } else {
      return of([]);
    }
  }

  aggiornaPreferiti(): Observable<any> {
    const language = this.translate.currentLang.toUpperCase();
    return this.apiService.utenteRegistratoGetWishlist({language, tipoOggetto: 'SCHEDA'}).pipe(map((res) => {
        if (res && res.preferiti) {
          this.storage.setLocal('preferiti-stem', res.preferiti);
          this.header.aggiornaPreferiti.emit();
          return res.preferiti;
        }
    }));
  }

  salvaPreferito(prodotto: any): Observable<any> {
    const language = this.translate.currentLang.toUpperCase();
    return this.apiService.utenteRegistratoSavePreferito({language, tipoOggetto: 'SCHEDA', idElemento: prodotto.id || prodotto.idScheda}).pipe(
      switchMap(() => this.aggiornaPreferiti())
    );
  }

  deletePreferito(prodotto: any): Observable<any> {
    const language = this.translate.currentLang.toUpperCase();
    return this.apiService.utenteRegistratoDeletePreferito({language, tipoOggetto: 'SCHEDA', idElemento: prodotto.id || prodotto.idScheda}).pipe(
      switchMap(() => this.aggiornaPreferiti())
    );
  }

}
